export default {
    // Header Section
    "discover_your": "अपने",
    "year_analysis": "वर्ष विश्लेषण",
    "yearly_cosmic_insights": "वार्षिक ब्रह्मांडीय अंतर्दृष्टि",
    "year_analysis_description": "वैदिक ज्योतिष और अंकशास्त्र के आधार पर व्यापक वार्षिक विश्लेषण प्राप्त करें। अपने वर्ष के विषयों, मासिक भविष्यवाणियों, शुभ अवधि, चुनौतियों और पूरे वर्ष सफलता के लिए व्यक्तिगत मार्गदर्शन को समझें।",

    "know_your": "अपने",

    // Service Information
    "enter_details_for_year_analysis": "वर्ष विश्लेषण के लिए अपना विवरण दर्ज करें",
    "complete_year_analysis": "संपूर्ण वर्ष विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_year_analysis_note": "मासिक भविष्यवाणियों और समय मार्गदर्शन के साथ विस्तृत वार्षिक पूर्वानुमान",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_yearly_influence": "आपका नाम वार्षिक तरंगों और वार्षिक चक्रों को प्रभावित करता है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_yearly_cycles": "व्यक्तिगत वर्ष चक्र और वार्षिक भविष्यवाणियों की गणना के लिए आवश्यक",
    "analysis_year": "विश्लेषण वर्ष",
    "year_2024": "2024",
    "year_2025": "2025",
    "year_2026": "2026",
    "select_year_for_analysis": "जिस वर्ष का विस्तृत विश्लेषण चाहते हैं उसे चुनें",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपका वर्ष विश्लेषण चुनी गई भाषा में प्रदान किया जाएगा",

    // Core Year Features
    "complete_yearly_forecast": "संपूर्ण वार्षिक पूर्वानुमान",
    "monthly_breakdown_analysis": "मासिक विभाजन विश्लेषण",
    "major_life_events_timing": "प्रमुख जीवन घटनाओं का समय",
    "favorable_unfavorable_periods": "अनुकूल और प्रतिकूल अवधि",
    "yearly_remedies_guidance": "वार्षिक उपचार और मार्गदर्शन",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपके वर्ष विश्लेषण में क्या शामिल है",
    "comprehensive_yearly_roadmap": "व्यापक वार्षिक रोडमैप",
    "month_by_month_predictions": "महीने दर महीने भविष्यवाणियां",
    "auspicious_timing_guide": "शुभ समय मार्गदर्शिका",
    "yearly_remedial_solutions": "वार्षिक उपचारात्मक समाधान",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरा वर्ष विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "विश्लेषण तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "year_analysis_processing": "आपका व्यापक वर्ष विश्लेषण हमारे विशेषज्ञ ज्योतिषियों द्वारा तैयार किया जा रहा है। आपको विस्तृत मासिक भविष्यवाणियां और वार्षिक मार्गदर्शन प्राप्त होगा।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_18_hours_delivery_note": "आपका विस्तृत वर्ष विश्लेषण 18 घंटों के भीतर तैयार हो जाएगा",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरा विश्लेषण इस पर भेजा गया",

    // What You'll Receive
    "what_youll_receive": "आपका वर्ष विश्लेषण पैकेज",
    "detailed_year_analysis": "विस्तृत वर्ष विश्लेषण रिपोर्ट (पीडीएफ)",
    "monthly_predictions_calendar": "मासिक भविष्यवाणी कैलेंडर",
    "auspicious_dates_timing": "शुभ तिथियां और समय",
    "yearly_remedies_guide": "वार्षिक उपचार गाइड",
    "life_events_forecast": "जीवन घटनाओं का पूर्वानुमान",

    // Visual Content
    "sample_year_analysis": "नमूना वर्ष विश्लेषण",
    "yearly_theme": "वार्षिक थीम",
    "sample_yearly_reading": "वित्तीय स्थिरता फोकस के साथ विकास और परिवर्तन",
    "sample_year_preview": "मासिक अंतर्दृष्टि के साथ आपके व्यक्तिगत वर्ष विश्लेषण का पूर्वावलोकन",
    "monthly_overview": "मासिक अवलोकन",

    // Month Abbreviations
    "jan": "जन",
    "feb": "फर",
    "mar": "मार्च",
    "apr": "अप्र",
    "may": "मई",
    "jun": "जून",
    "jul": "जुल",
    "aug": "अग",
    "sep": "सित",
    "oct": "अक्ट",
    "nov": "नव",
    "dec": "दिस",

    // Status & Processing
    "your_year_analysis_status": "आपके वर्ष विश्लेषण की स्थिति",
    "processing_your_analysis": "आपके वर्ष का विश्लेषण",
    "analysis_processing_message": "हमारे विशेषज्ञ ज्योतिषी मासिक भविष्यवाणियों और समय मार्गदर्शन के साथ आपका व्यापक वर्ष विश्लेषण तैयार कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_18_hours": "रिपोर्ट 18 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "वर्ष विश्लेषण सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // Year-Specific Elements
    "personal_year_number": "व्यक्तिगत वर्ष संख्या",
    "annual_theme": "वार्षिक थीम",
    "year_vibration": "वर्ष कंपन",
    "yearly_cycles": "वार्षिक चक्र",
    "annual_lessons": "वार्षिक सबक",
    "year_challenges": "वर्ष चुनौतियां",

    // Monthly Analysis
    "january_analysis": "जनवरी विश्लेषण",
    "february_analysis": "फरवरी विश्लेषण",
    "march_analysis": "मार्च विश्लेषण",
    "april_analysis": "अप्रैल विश्लेषण",
    "may_analysis": "मई विश्लेषण",
    "june_analysis": "जून विश्लेषण",
    "july_analysis": "जुलाई विश्लेषण",
    "august_analysis": "अगस्त विश्लेषण",
    "september_analysis": "सितंबर विश्लेषण",
    "october_analysis": "अक्टूबर विश्लेषण",
    "november_analysis": "नवंबर विश्लेषण",
    "december_analysis": "दिसंबर विश्लेषण",

    // Quarterly Analysis
    "first_quarter": "पहली तिमाही (जन-मार्च)",
    "second_quarter": "दूसरी तिमाही (अप्र-जून)",
    "third_quarter": "तीसरी तिमाही (जुल-सित)",
    "fourth_quarter": "चौथी तिमाही (अक्ट-दिस)",
    "quarterly_themes": "तिमाही थीम",
    "seasonal_influences": "मौसमी प्रभाव",

    // Life Areas Yearly Focus
    "career_year_focus": "करियर वर्ष फोकस",
    "love_relationships_year": "प्रेम और रिश्ते वर्ष",
    "health_wellness_year": "स्वास्थ्य और कल्याण वर्ष",
    "financial_year_outlook": "वित्तीय वर्ष दृष्टिकोण",
    "family_social_year": "पारिवारिक और सामाजिक वर्ष",
    "spiritual_growth_year": "आध्यात्मिक विकास वर्ष",

    // Timing & Periods
    "peak_success_periods": "चरम सफलता अवधि",
    "challenging_periods": "चुनौतीपूर्ण अवधि",
    "neutral_periods": "तटस्थ अवधि",
    "transformation_phases": "परिवर्तन चरण",
    "opportunity_windows": "अवसर की खिड़कियां",
    "caution_periods": "सावधानी अवधि",

    // Auspicious Timing
    "best_months_for_new_ventures": "नए उद्यमों के लिए सर्वोत्तम महीने",
    "favorable_travel_periods": "अनुकूल यात्रा अवधि",
    "auspicious_wedding_dates": "शुभ विवाह तिथियां",
    "good_investment_timing": "अच्छा निवेश समय",
    "career_change_timing": "करियर परिवर्तन समय",
    "property_purchase_timing": "संपत्ति खरीदारी समय",

    // Annual Predictions
    "career_predictions": "करियर भविष्यवाणियां",
    "business_forecast": "व्यापार पूर्वानुमान",
    "financial_outlook": "वित्तीय दृष्टिकोण",
    "relationship_predictions": "रिश्ते की भविष्यवाणियां",
    "health_forecast": "स्वास्थ्य पूर्वानुमान",
    "family_predictions": "पारिवारिक भविष्यवाणियां",

    // Success Factors
    "key_success_factors": "मुख्य सफलता कारक",
    "growth_opportunities": "विकास के अवसर",
    "skill_development_focus": "कौशल विकास फोकस",
    "networking_opportunities": "नेटवर्किंग अवसर",
    "leadership_potential": "नेतृत्व क्षमता",
    "creative_expression": "रचनात्मक अभिव्यक्ति",

    // Challenges & Solutions
    "potential_obstacles": "संभावित बाधाएं",
    "problem_solving_guidance": "समस्या समाधान मार्गदर्शन",
    "stress_management": "तनाव प्रबंधन",
    "conflict_resolution": "संघर्ष समाधान",
    "decision_making_support": "निर्णय लेने का समर्थन",
    "risk_mitigation": "जोखिम कम करना",

    // Personal Development
    "character_development": "चरित्र विकास",
    "habit_formation": "लाभकारी आदत निर्माण",
    "goal_setting_guidance": "लक्ष्य निर्धारण मार्गदर्शन",
    "motivation_factors": "प्रेरणा कारक",
    "confidence_building": "आत्मविश्वास निर्माण",
    "self_improvement_areas": "आत्म सुधार क्षेत्र",

    // Relationship Year
    "love_life_forecast": "प्रेम जीवन पूर्वानुमान",
    "marriage_prospects": "विवाह संभावनाएं",
    "family_harmony": "पारिवारिक सद्भावना",
    "friendship_developments": "मित्रता विकास",
    "social_connections": "सामाजिक संबंध",
    "partnership_opportunities": "साझेदारी के अवसर",

    // Financial Year
    "income_growth_potential": "आय वृद्धि क्षमता",
    "expenditure_patterns": "व्यय पैटर्न",
    "investment_guidance": "निवेश मार्गदर्शन",
    "debt_management": "ऋण प्रबंधन",
    "savings_opportunities": "बचत के अवसर",
    "financial_planning": "वित्तीय योजना",

    // Health Year
    "vitality_levels": "जीवन शक्ति स्तर",
    "health_maintenance": "स्वास्थ्य रखरखाव",
    "fitness_goals": "फिटनेस लक्ष्य",
    "wellness_practices": "कल्याण अभ्यास",
    "preventive_care": "निवारक देखभाल",
    "mental_health_focus": "मानसिक स्वास्थ्य फोकस",

    // Career Year
    "professional_growth": "व्यावसायिक विकास",
    "job_opportunities": "नौकरी के अवसर",
    "skill_enhancement": "कौशल वृद्धि",
    "leadership_roles": "नेतृत्व भूमिकाएं",
    "career_transitions": "करियर संक्रमण",
    "recognition_achievements": "मान्यता और उपलब्धियां",

    // Spiritual Year
    "spiritual_awakening": "आध्यात्मिक जागृति",
    "meditation_practices": "ध्यान अभ्यास",
    "inner_growth": "आंतरिक विकास",
    "wisdom_development": "बुद्धिमत्ता विकास",
    "divine_connections": "दिव्य संबंध",
    "karmic_lessons": "कार्मिक सबक",

    // Travel & Adventure
    "travel_opportunities": "यात्रा के अवसर",
    "adventure_potential": "साहसिक क्षमता",
    "cultural_experiences": "सांस्कृतिक अनुभव",
    "educational_journeys": "शैक्षिक यात्राएं",
    "pilgrimage_possibilities": "तीर्थयात्रा संभावनाएं",
    "foreign_connections": "विदेशी संबंध",

    // Learning & Education
    "learning_opportunities": "सीखने के अवसर",
    "skill_certifications": "कौशल प्रमाणन",
    "knowledge_expansion": "ज्ञान विस्तार",
    "teaching_possibilities": "शिक्षण संभावनाएं",
    "research_projects": "अनुसंधान परियोजनाएं",
    "academic_pursuits": "शैक्षणिक गतिविधियां",

    // Creative & Artistic
    "creative_projects": "रचनात्मक परियोजनाएं",
    "artistic_expression": "कलात्मक अभिव्यक्ति",
    "innovative_ideas": "नवाचार विचार",
    "creative_collaborations": "रचनात्मक सहयोग",
    "artistic_recognition": "कलात्मक मान्यता",
    "creative_income": "रचनात्मक आय क्षमता",

    // Social & Community
    "community_involvement": "सामुदायिक भागीदारी",
    "social_influence": "सामाजिक प्रभाव",
    "public_recognition": "सार्वजनिक मान्यता",
    "group_activities": "समूहिक गतिविधियां",
    "social_causes": "सामाजिक कारण",
    "humanitarian_work": "मानवीय कार्य",

    // Technology & Innovation
    "technological_adaptation": "तकनीकी अनुकूलन",
    "digital_opportunities": "डिजिटल अवसर",
    "innovation_potential": "नवाचार क्षमता",
    "online_presence": "ऑनलाइन उपस्थिति",
    "tech_skill_development": "तकनीकी कौशल विकास",
    "digital_transformation": "डिजिटल परिवर्तन"
};
